import { createContext, type ReactNode, useContext, useMemo } from 'react'
import { useLocation } from 'react-router-dom'

type TenderListContextType = {
  token: string
  sourceTenderUUID: string | null
}

const TenderListContext = createContext<TenderListContextType | undefined>(undefined)

export function useTenderListContext(): TenderListContextType {
  const context = useContext(TenderListContext)
  if (!context) {
    throw new Error('useTenderListContext must be used within a TenderListContextProvider')
  }
  return context
}

export function TenderListContextProvider({ children }: { children: ReactNode }) {
  const { search } = useLocation()
  const params = new URLSearchParams(search)
  const token = params.get('token') ?? ''
  const sourceTenderUUID = params.get('tender_uuid')

  const value = useMemo(() => ({ token, sourceTenderUUID }), [token, sourceTenderUUID])

  return <TenderListContext.Provider value={value}>{children}</TenderListContext.Provider>
}
